import axiosInterceptor from "../../utils/axiosInterseptor";

export const updateProfileRoute = (data) => axiosInterceptor.put(`/admin/updateAdminProfile`, data)